import styled from 'styled-components';

export const FormModalContainer = styled.div`
    width: 569px;
    padding: 20px;

    background-color: #000;
    border-radius: 16px;
    border: 1px solid #353535;
    position: relative;

    display: flex;
    justify-content: center;
`;

export const FormModalContent = styled.div`
    width: 350px;

    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SearchInput = styled.input`
    width: 100%;
    height: 30px;
    border-radius: 3px;
    border: none;
    background-color: rgba(239, 240, 242, 0.18);
    text-align: center;
    font-size: 14px;
    color: #909fac;
    outline: none;
    margin-bottom: 10px;
`;

export const UsersContainer = styled.div`
    width: 100%;
    min-height: 100px;
    max-height: 400px;
    // height: 500px;

    overflow: scroll;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const AddViaEmailBlock = styled.div`
    width: 100%;
    margin: 12px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const AddViaEmailButton = styled.button`
    width: 99px;
    height: 23px;
    border-radius: 100px;
    background-image: linear-gradient(to bottom, #ff6b00, #fa2462);
    text-transform: uppercase;
    color: white;
    font-weight: 100;
    border: none;
    cursor: pointer;
    transition: all 0.25s;
    outline: none;

    &:hover {
        opacity: 0.75;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/AddMemberModal/style.js